// theme/themeApi.ts
import { apiClient } from '../services/api-client';
import { normaliseStoredPreference, type ThemePreference } from './resolveEffectiveTheme';

interface ThemeResponse {
  themePreference: ThemePreference;
}

/** GET the stored theme preference; normalises any unrecognised value to 'System'. */
export async function getThemePreference(): Promise<ThemePreference> {
  const data = await apiClient.get<ThemeResponse>('/settings/theme');
  return normaliseStoredPreference(data.themePreference);
}

/** Persist the theme preference. */
export async function putThemePreference(themePreference: ThemePreference): Promise<void> {
  await apiClient.put('/settings/theme', { themePreference });
}
